module.exports = __webpack_public_path__ + "static/media/Udinese.dc545a21.png";